import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll send a secure reset link."
      footer={<><Link to="/login" className="text-[#2563EB] font-medium" data-testid="link-back-login">Back to sign in</Link></>}
    >
      {sent ? (
        <div className="rounded-md border border-green-200 bg-green-50 p-5 flex gap-3" data-testid="forgot-success">
          <MailCheck className="text-green-600 shrink-0" size={22} />
          <div>
            <p className="font-medium text-green-800">Check your inbox</p>
            <p className="text-sm text-green-700 mt-1">
              If an account exists for <span className="font-mono">{email}</span>, a reset link is on its way. The link expires in 1 hour.
            </p>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input"
              className="mt-1.5 w-full h-11 px-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-[#2563EB] focus:border-[#2563EB] outline-none"
              placeholder="you@company.com"
            />
          </div>
          <button
            type="submit" disabled={loading}
            data-testid="forgot-submit-button"
            className="w-full h-11 rounded-md bg-[#2563EB] text-white font-medium hover:bg-[#1D4ED8] transition-colors flex items-center justify-center disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
